<template>
  <div>
    <!-- BEGIN: Left Aside -->
    <div
      id="m_aside_left"
      class="m-grid__item m-aside-left m-aside-left--skin-dark"
    >
      <!-- BEGIN: Aside Menu -->
      <div
        id="m_ver_menu"
        class="m-aside-menu m-aside-menu--skin-dark m-aside-menu--submenu-skin-dark"
        :m-menu-vertical="'1'"
        :m-menu-scrollable="'1'"
        :m-menu-dropdown-timeout="'500'"
        style="position: relative"
      >
        <ul class="m-menu__nav m-menu__nav--dropdown-submenu-arrow">
          <!-- start: Dashboard -->
          <router-link
            tag="li"
            :to="getRouter('Dashboard')"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="getRouter('Dashboard')"
              active-class="m-menu__item--active"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-dashboard" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("menus.main.overview")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <!-- end: Dashboard -->

          <!-- start: Properties -->

          <li class="m-menu__section">
            <h3 class="m-menu__section-text">
              {{ $t("menus.main.properties") }}
            </h3>
            <i class="m-menu__section-icon flaticon-more-v2" />
          </li>

          <router-link
            tag="li"
            :to="{ name: 'Properties', query: queryRoute }"
            exact
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'Properties', query: queryRoute }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-signs-1" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("menus.main.listings")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            tag="li"
            :to="{ name: 'FeaturedProperties' }"
            exact
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'FeaturedProperties' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon la la-star-o" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("menus.main.featured")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            tag="li"
            :to="{ name: 'PropertiesAnalytics' }"
            :exact="!routePropAnalytics"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'PropertiesAnalytics' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-diagram" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span :class="{ 'm-menu__link-text': true }">{{
                    $t("menus.main.analytics")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            tag="li"
            :to="{ name: 'PropertiesEnquiries' }"
            :exact="!routePropEnqList"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'PropertiesEnquiries' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-mail" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span :class="{ 'm-menu__link-text': true }">{{
                    $t("menus.main.enquiries")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            tag="li"
            :to="{ name: 'DataFeed', query: queryRoute }"
            :exact="!routeDataFeed"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'DataFeed' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-file" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span :class="{ 'm-menu__link-text': true }">{{
                    $t("menus.main.dataFeeds")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <!-- <router-link
            tag="li"
            :to="{ name: 'XmlImportReport', query: queryRoute }"
            :exact="!routeXmlImportReport"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link :to="{ name: 'XmlImportReport' }" class="m-menu__link">
              <i class="m-menu__link-icon flaticon-file"></i>
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span :class="{ 'm-menu__link-text': true }">{{
                    $t("menus.main.xmlImportReport")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link> -->

          <!-- end: Properties -->

          <!-- start: Directories -->

          <li class="m-menu__section">
            <h4 class="m-menu__section-text">
              {{ $t("menus.main.businessdir") }}
            </h4>
            <i class="m-menu__section-icon flaticon-more-v2" />
          </li>

          <router-link
            tag="li"
            :to="{ name: 'Directories' }"
            :exact="!routeDirList"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'Directories' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-signs-1" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span :class="{ 'm-menu__link-text': true }">{{
                    $t("menus.main.businessProfile")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            tag="li"
            :to="{ name: 'DirectoriesAnalytics' }"
            :exact="!routeDirAnalytics"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'DirectoriesAnalytics' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-diagram" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span :class="{ 'm-menu__link-text': true }">{{
                    $t("menus.main.analytics")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            tag="li"
            :to="{ name: 'DirectoriesEnquiries' }"
            :exact="!routeDirEnqList"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'DirectoriesEnquiries' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-mail" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span :class="{ 'm-menu__link-text': true }">{{
                    $t("menus.main.enquiries")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <!-- end: Directories -->

          <li class="m-menu__separator" />

          <router-link
            tag="li"
            :to="{ name: 'Advertise' }"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'Advertise' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-line-graph" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("advertise.AdvertiseProperty")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            tag="li"
            :to="{ name: 'AdvertiseDir' }"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'AdvertiseDir' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-line-graph" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("advertise.AdvertiseDirectoryv2")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <li
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <a
              :href="orderStickerLink()"
              class="m-menu__link"
              target="_blank"
            >
              <i class="m-menu__link-icon flaticon-notes" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("advertise.OrderStickers")
                  }}</span>
                </span>
              </span>
            </a>
          </li>

          <li
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <a
              href="https://www.thinkspain.com/advertise/job"
              class="m-menu__link"
              target="_blank"
            >
              <i class="m-menu__link-icon flaticon-suitcase" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("advertise.AdvertiseJob")
                  }}</span>
                </span>
              </span>
            </a>
          </li>

          <li class="m-menu__separator" />

          <router-link
            tag="li"
            :to="{ name: 'Invoicing' }"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'Invoicing' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-piggy-bank" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("menus.user.invoicing")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <li
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <a
              :href="rateCardURL"
              class="m-menu__link"
              target="_blank"
            >
              <i class="m-menu__link-icon flaticon-piggy-bank" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("menus.user.rateCard")
                  }}</span>
                </span>
              </span>
            </a>
          </li>

          <router-link
            tag="li"
            :to="{ name: 'TermsOfService' }"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'TermsOfService' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-exclamation-1" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("menus.user.termsofservice")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <!-- start: Help -->
          <router-link
            tag="li"
            :to="{ name: 'Support' }"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'Support' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-support" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("common.support")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>

          <router-link
            v-if="false"
            tag="li"
            :to="{ name: 'FAQ' }"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'FAQ' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-exclamation-2" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{ $t("common.faq") }}</span>
                </span>
              </span>
            </router-link>
          </router-link>
          <!-- end: Help -->

          <li class="m-menu__separator" />

          <!-- start: LOGOUT -->

          <router-link
            tag="li"
            :to="{ name: 'Logout' }"
            active-class="m-menu__item--active"
            class="m-menu__item"
          >
            <router-link
              :to="{ name: 'Logout' }"
              class="m-menu__link"
            >
              <i class="m-menu__link-icon flaticon-logout" />
              <span class="m-menu__link-title">
                <span class="m-menu__link-wrap">
                  <span class="m-menu__link-text">{{
                    $t("menus.user.logout")
                  }}</span>
                </span>
              </span>
            </router-link>
          </router-link>
          <!-- end: LOGOUT -->
        </ul>
      </div>

      <!-- END: Aside Menu -->
    </div>
    <!-- END: Left Aside -->
  </div>
</template>
<script>
import { getUser } from '../../../../functions.ts';
import { rateCardsURLSByLanguage } from '../../../../common/rates.js';

export default {
    data() {
        return {
            queryRoute: null,
            user: {},
        };
    },
    computed: {
        rateCardURL() {
            return rateCardsURLSByLanguage[ this.$i18n.locale || 'es' ];
        },
        routePropList() {
            if ( typeof this.$route.query.action !== 'undefined' ) {
                this.queryRoute = { action: 'openPI' };
            }

            return this.$route.name === 'Properties';
        },
        routeFeatPropList() {
            return this.$route.name === 'FeaturedProperties';
        },
        routePropEnqList() {
            return this.$route.name === 'PropertiesEnquiries';
        },
        routePropAnalytics() {
            return this.$route.name === 'PropertiesAnalytics';
        },
        routeDirList() {
            return this.$route.name === 'Directories';
        },
        routeDataFeed() {
            return this.$route.name === 'DataFeed';
        },
        routeXmlImportReport() {
            return this.$route.name === 'XmlImportReport';
        },
        routeDirEnqList() {
            return this.$route.name === 'DirectoriesEnquiries';
        },
        routeDirAnalytics() {
            return this.$route.name === 'DirectoriesAnalytics';
        },
        routeProp() {
            return typeof this.$route.query.dateRange !== 'undefined';
        },
    },
    async mounted() {
        this.user = getUser();
    },
    methods: {
        getRouter( name ) {
            if ( name === 'Dashboard' ) {
                if ( this.$router.currentRoute.name !== name ) {
                    return { name: 'Dashboard',
                        query: { stats: 'tAgo' } };
                } else {
                    return this.$router.currentRoute.fullPath;
                }
            }
        },
        orderStickerLink() {
            const params = new URLSearchParams();

            if ( this.user && this.user.Login ) {
                params.set( 'login', this.user.Login );
            }

            return `https://www.thinkspain.com/${this.$i18n.locale === 'es' ? 'es/' : ''}order-window-stickers?` + params.toString();
        },
    },
};
</script>
